import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectionHeader({ title, slug, accent = "watergreen", testId }) {
  const accentClass = accent === "turquoise" ? "bg-turquoise" : "bg-watergreen";
  return (
    <div data-testid={testId} className="flex items-end justify-between mb-6 gap-4 flex-wrap">
      <h2 className="section-title flex items-center">
        <span className={`inline-block h-[3px] w-10 mr-3 align-middle ${accentClass}`}></span>
        {title}
      </h2>
      {slug && (
        <Link
          to={`/categoria/${slug}`}
          className="text-xs uppercase tracking-[0.18em] font-semibold text-petroleum hover:text-turquoise transition-colors inline-flex items-center gap-1"
        >
          Ver más <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      )}
    </div>
  );
}
